"use client";

// Quien ya entró no aterriza en la landing: va directo al inicio de su módulo.
// La landing es para venderle Busco al que todavía no lo conoce; al local que
// entra todas las mañanas, verla de nuevo es un peaje.
//
// El dueño reportó el parpadeo: se veía la landing un instante y recién después
// saltaba al módulo. Dos arreglos:
//  1. El destino se cachea (INICIO_KEY, lo escribe NavSuperior al conocer los
//     roles): si está, se redirige al instante sin esperar a /auth/me.
//  2. Mientras se decide, una cortina opaca con la marca tapa la landing: se ve
//     "abriendo tu Busco", no una página que aparece y se va.
import { useRouter } from "next/navigation";
import { useEffect, useState } from "react";
import { INICIO_KEY, api, hasSession } from "../lib/api";
import { inicioDe } from "./NavSuperior";

export default function IrAlModulo() {
  const router = useRouter();
  const [cortina, setCortina] = useState(false);

  useEffect(() => {
    if (!hasSession()) return;
    setCortina(true);

    const cacheado = localStorage.getItem(INICIO_KEY);
    if (cacheado && cacheado.startsWith("/") && !cacheado.startsWith("//")) {
      // replace y no push: la landing no queda en el historial y "volver" no rebota
      router.replace(cacheado);
      return;
    }

    let vivo = true;
    api<{ roles: { role: string }[] }>("/auth/me")
      .then((yo) => {
        if (!vivo) return;
        const destino = inicioDe(yo.roles.map((r) => r.role));
        localStorage.setItem(INICIO_KEY, destino);
        router.replace(destino);
      })
      // Si /auth/me falla (señal, servidor), se corre la cortina y queda la
      // landing: es un destino válido y siempre tiene la barra para navegar.
      .catch(() => { if (vivo) setCortina(false); });
    return () => { vivo = false; };
  }, [router]);

  if (!cortina) return null;
  return (
    <div className="fixed inset-0 z-[100] bg-[#14191B] grid place-items-center" aria-hidden>
      <div className="flex items-center gap-3 animate-pulse">
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img src="/icon.svg" alt="" width={40} height={40} className="rounded-xl" />
        <span className="font-bold text-2xl tracking-tight text-[#EDF1EF]">busco</span>
      </div>
    </div>
  );
}
